// extracted by mini-css-extract-plugin
module.exports = {"navigator":"Navigator_navigator__3duOY","icon":"Navigator_icon__1iu2F","single":"Navigator_single__jX1vT"};